//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'LRVS',
  data() {
    return {
      form: {
        ss: '',
        sz: '',
        sex: '',
        height: '',
        weight: '',
      },
      sexList: [
        { value: '0', name: '男' },
        { value: '1', name: '女' },
      ],
      hasScore: false,
      disabled: false,
      num: '',
      num1: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res
        if (form.sex == 0) {
          res = 0.00607 * form.height + 0.0127 * form.weight - 0.0698
          self.num = form.ss / res
          self.num1 = form.sz / res
        } else {
          res = 0.00586 * form.height + 0.0126 * form.weight - 0.0461
          self.num = form.ss / res
          self.num1 = form.sz / res
        }
        self.num = self.num.toFixed(1)
        self.num1 = self.num1.toFixed(1)
        self.hasScore = true
        return String(self.num, self.num1)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/LRVS.vue